'use client'

import { useMediaQuery } from '@patrianna/shared-hooks'
import { notFound } from 'next/navigation'

import Page from 'components/Page'
import PageNotAvailable from 'pageContainers/PageNotAvailable'
import BackButtonLink from 'src/components/BackButtonLink'
import BuilderTextContent from 'src/components/BuilderTextContent'
import Loader from 'src/components/Loader'
import FooterPortal from 'src/containers/Layouts/Layout/FooterPortal'
import useBackUrl from 'src/hooks/useBackUrl'
import LogInToAccess from 'src/pageContainers/LogInToAccess'
import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector, sweepstakeEnabledSelector } from 'src/store/modules/appConfig/selectors'
import { isLoggedInSelector } from 'src/store/modules/user/selectors'

import type { BuilderContent } from 'app/utils/builder'

export default function SweepstakesRules(props: {
  content: BuilderContent | null
  builderPage: string
  backHref?: string
}) {
  const appInitialized = useAppSelector(isAppInitializedSelector)
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const isScEnabled = useAppSelector(sweepstakeEnabledSelector)
  const backUrl = useBackUrl({ backHref: props.backHref })
  const isMobile = useMediaQuery('xs')

  if (!appInitialized) {
    return <Loader />
  }

  if (!isLoggedIn) {
    return <LogInToAccess isDefaultLoginLink />
  }

  if (!isScEnabled) {
    return <PageNotAvailable />
  }

  if (!props.content) {
    notFound()
  }

  return (
    <Page>
      {isMobile && <BackButtonLink href={backUrl} />}
      <BuilderTextContent content={props.content} model={props.builderPage} />
      <FooterPortal />
    </Page>
  )
}
